import { validateAmounts } from "../utils";
import {
  EuerDeclarationOfficeUsageSubformFullCostInputs,
  HomeOwnershipType,
} from "./types";

const validateTotalAndOfficeAreas = ({
  totalHomeArea,
  officeArea,
}: {
  totalHomeArea: number;
  officeArea: number;
}): void => {
  if (officeArea >= totalHomeArea) {
    throw new Error("Office area should be less than total home area");
  }
};

const MAX_MONTHS_USED = 12;
const validateMonthsUsed = (monthsUsed: number): void => {
  if (monthsUsed > MAX_MONTHS_USED) {
    throw new Error(
      `Months used should be less or equal to ${MAX_MONTHS_USED}`
    );
  }
};

export const validateOfficeUsageInputs = (
  inputs: EuerDeclarationOfficeUsageSubformFullCostInputs
): void => {
  const {
    homeOwnershipType,
    totalHomeArea,
    officeArea,
    monthsUsed,
    usagePeriodOperatingHomeExpenses,
    annualOtherHomeExpenses,
    annualOtherOfficeExpenses,
    paidHomeExpensesInputTax16,
    paidHomeExpensesInputTax19,
    paidOfficeExpensesInputTax16,
    paidOfficeExpensesInputTax19,
  } = inputs;

  validateAmounts([
    totalHomeArea,
    officeArea,
    monthsUsed,
    homeOwnershipType === HomeOwnershipType.RENTAL
      ? inputs.monthlyRent
      : inputs.annualHomeDepreciation,
    usagePeriodOperatingHomeExpenses,
    annualOtherHomeExpenses,
    annualOtherOfficeExpenses,
    paidHomeExpensesInputTax16,
    paidHomeExpensesInputTax19,
    paidOfficeExpensesInputTax16,
    paidOfficeExpensesInputTax19,
  ]);
  validateTotalAndOfficeAreas({ totalHomeArea, officeArea });
  validateMonthsUsed(monthsUsed);
};
